import { Navigate, Outlet } from "react-router-dom";

const AdminPrivateRoute = () => {
  const token = sessionStorage.getItem("accessToken");
  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default AdminPrivateRoute;